import { httpRequest } from "../../http";

export class CommandDownloadFile {
  async run(fileId: number): Promise<{ url: string }> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/files/${fileId}/download/`;
    return httpRequest<{ url: string }>(url, { method: "GET" });
  }
}
